var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1745463858081,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2914,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467.781818 150.626263h88.307071V636.121212c0 13.187879-8.791919 22.109091-22.109091 22.109091h-44.088889c-13.187879 0-22.109091-8.791919-22.109091-22.109091V150.626263z m0 0",
    fill: "#1890FF",
    "p-id": 2915
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M309.010101 388.913131l-30.90101-30.90101c-8.791919-8.791919-8.791919-22.109091 0-30.90101l218.50505-218.50505c8.791919-8.791919 22.109091-8.791919 30.901011 0l46.286868 46.286868-234.020202 234.020202c-8.791919 8.791919-21.979798 8.791919-30.771717 0z m0 0",
    fill: "#1890FF",
    "p-id": 2916
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M450.19798 155.022222L496.484848 108.606061c8.791919-8.791919 22.109091-8.791919 30.901011 0l218.50505 218.50505c8.791919 8.791919 8.791919 22.109091 0 30.90101l-30.90101 30.90101c-8.791919 8.791919-22.109091 8.791919-30.90101 0L450.19798 155.022222z m458.989899 348.573738h-44.088889c-13.187879 0-22.109091 8.791919-22.109091 22.109091v286.90101c0 13.187879-8.791919 22.109091-22.109091 22.109091H202.989899c-13.187879 0-22.109091-8.791919-22.109091-22.109091V525.705051c0-13.187879-8.791919-22.109091-22.109091-22.109091h-43.959596c-13.187879 0-22.109091 8.791919-22.109091 22.109091v375.078787c0 13.187879 8.791919 22.109091 22.109091 22.109091h794.375758c13.187879 0 22.109091-8.791919 22.109091-22.109091V525.705051c-0.129293-13.187879-8.921212-22.109091-22.109091-22.109091z m0 0",
    fill: "#1890FF",
    "p-id": 2917
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M269.187879 591.90303H136.791919v-88.30707h132.39596c13.187879 0 22.109091 8.791919 22.109091 22.109091v44.088888c0 11.119192-8.791919 22.109091-22.109091 22.109091z m617.890909 0H754.682828c-13.187879 0-22.109091-8.791919-22.109091-22.109091v-44.088888c0-13.187879 8.791919-22.109091 22.109091-22.109091h132.39596v88.30707z m0 0",
    fill: "#1890FF",
    "p-id": 2918
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/导出.5ef57caa3404c0f349786bf3f0f0d0f9.svg";
export { ForwardRef as ReactComponent };